import React from "react"

const CookieAlert = () => {
  return <React.Fragment />
}

export default CookieAlert;
